import { AppointmentSchedulingServant, STCSchedulingConfigModel } from 'data-ng-custom-text';
import { ICommand } from 'core-ts-types';
import { PathTask } from 'capability-ng-todos';

export interface IPreviousState {
  state: string;
  params: object;
}

export class MyTodosAppointmentRequestDetailsController {
  models: any;

  constructor(
    private pathTaskDetail: any,
    private taskUpdateFn: any,
    private log: any,
    private appointmentRequestDetails: any,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private appointmentPathItemFn: any,
    private prepareAppointmentCampaignRequestCommand: ICommand,
    private previousState: IPreviousState,
    private ngStcSchedulingConfigModel: STCSchedulingConfigModel,
    private ngAppointmentSchedulingServant: AppointmentSchedulingServant
  ) {
    this._initialize();

  }

  _initialize(): void {
    this.models = {
      taskDetails: this.pathTaskDetail,
      topic: this.$stateParams.topic,
      task: this.pathTaskDetail.source.task,
      appointmentRequest: this.appointmentPathItemFn.generateAppointmentRequestDetails(this.appointmentRequestDetails)
    };
  }

  isDismissible(task: PathTask): boolean {
    return task.is_dismissible && !this.taskUpdateFn.isCompleted(task);
  }

  scheduleAppointment(): void {

    this.ngAppointmentSchedulingServant.getSchedulingConfig().then(() => {
      this.prepareAppointmentCampaignRequestCommand(this.models.appointmentRequest).then(() => {
        const returnState = { state: this.previousState.state, params: this.previousState.params };

        window['$ip'].require('@eab-pip/pi-navigation').then((nav) => {
          setTimeout(() => {
            if (this.ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) {
              const appointmentInvitationRoute = nav.uri.write('#/my/host/as3/appointment-invitation-results', {
                invitation_id: this.models.appointmentRequest.id
              });

              window.location.assign(appointmentInvitationRoute);
            } else {
              const appointmentAvailableTimesRoute = nav.uri.write('#/my/host/as3/appointments/available_times/', {
                invitation_id: this.models.appointmentRequest.id,
                returnState
              });

              window.location.assign(appointmentAvailableTimesRoute);
            }
          }, 700);

        });
      });
    });
  }

  getHideText(isDimissed: boolean) {
    return !isDimissed ? 'Hide' : 'Unhide';
  }

  isDismissed(task: PathTask): boolean {
    return this.taskUpdateFn.isDismissed(task);
  }

  toggleDismissed(task: PathTask): void {
    const initialStatus = task.status;
    task.status = this.taskUpdateFn.getNewStatusAsString(task, initialStatus, true);

    this.taskUpdateFn.toggleDismissed(task, initialStatus, false).then(
      (updatedTask: PathTask) => {
        this.models.task = updatedTask;
      },
      (err: any) => {
        this.models.task.status = initialStatus;
        this.log.user.error(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos_appointment_request_details/my_todos_appointment_request_details_controller.ts